import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'react-fa'
import './LaneHeader.scss'

const LaneHeader = (props) => {
  return (
    <header style={{ transform: `translateX(-${props.scrollLeft}px)` }} className='lane-header'>
      <div>{props.name}</div>
      {props.onAddCard && (<Icon name='plus-circle' className={'task-add-button'} onClick={props.onAddCard} />)}
    </header>
  )
}

LaneHeader.propTypes = {
  name: PropTypes.string.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  onAddCard: PropTypes.func
}

export default LaneHeader



// WEBPACK FOOTER //
// ./src/routes/Board/components/LaneHeader.js